'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const header = css`
  text-align: center;
  background: white;
  z-index: 30;
  @media screen and (width > ${theme.sizes.screens.md}) {
    z-index: 40;
    text-align: initial;
  }
`;

export const subtitle = css`
  color: ${theme.colors.peoople['gris-medio']};
`;

export const title = css`
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1em;
  max-width: 50%;
`;
